<form [formGroup]="form">
    <div fxLayout="column" fxLayoutAlign="start">
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="100" class="px-4">
                <mat-label>Tipo Beneficiario*</mat-label>
                <input matInput formControlName="a4TipoBeneficiario" [matAutocomplete]="autoTipoBen">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoTipoBen="matAutocomplete" [displayWith]="displayFn"
                                  (optionSelected)="onTipoSelected($event.option)">
                    <mat-option *ngFor="let option of tipoFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch" *ngIf="!institucion">
            <mat-form-field appearance="outline" fxFlex="33" class="px-4">
                <mat-label>Nombre*</mat-label>
                <input matInput formControlName="a4NombreBeneficiario">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="33" class="px-4">
                <mat-label>Primer Apellido*</mat-label>
                <input matInput formControlName="a4PrimerApellidoBeneficiario">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="33" class="px-4">
                <mat-label>Segundo Apellido</mat-label>
                <input matInput formControlName="a4SegundoApellidoBeneficiario">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch" *ngIf="!institucion">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>CURP*</mat-label>
                <input matInput formControlName="a4CURPBeneficiario">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>RFC*</mat-label>
                <input matInput formControlName="a4ClaveElectorBeneficiario">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch" *ngIf="!institucion">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Sexo*</mat-label>
                <input matInput formControlName="a4SexoBeneficiario" [matAutocomplete]="autoSexoBen">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoSexoBen="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of sexoFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Estado Civil</mat-label>
                <input matInput formControlName="a4EstadoCivilBeneficiario" [matAutocomplete]="autoEstadoBen">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoEstadoBen="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of estadoFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch" *ngIf="!institucion">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Fecha Nacimiento*</mat-label>
                <input matInput
                    formControlName="a4FechaNacimientoBeneficiario"
                    [matDatepicker]="fechaNacimientoPicker"
                   (dateChange)="dateChange($event)"
                >
                <mat-datepicker-toggle matSuffix [for]="fechaNacimientoPicker"></mat-datepicker-toggle>
                <mat-datepicker #fechaNacimientoPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Edad*</mat-label>
                <input matInput formControlName="a4EdadBeneficiario" readonly="readonly">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch" *ngIf="!institucion">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Ocupacion*</mat-label>
                <input matInput formControlName="a4OcupacionBeneficiario" [matAutocomplete]="autoOcupacionBen">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoOcupacionBen="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of ocupacionFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Etnia*</mat-label>
                <input matInput formControlName="a4EtniaBeneficiario" [matAutocomplete]="autoEtniaBen">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoEtniaBen="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of etniaFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch" *ngIf="!institucion">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Teléfono*</mat-label>
                <input matInput formControlName="a4BeneficiarioTelefono">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Integrantes Familia*</mat-label>
                <input matInput formControlName="a4IntegrantesDeFamiliaBeneficiario">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch" *ngIf="!institucion">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Tipo Población*</mat-label>
                <input matInput formControlName="a4TipoPoblacionBeneficiario" [matAutocomplete]="autoPoblacionBen">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoPoblacionBen="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of poblacionFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch" *ngIf="institucion">
            <mat-form-field appearance="outline" fxFlex="100" class="px-4">
                <mat-label>Nombre Institución*</mat-label>
                <input matInput formControlName="a4NombreInstitucion">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch" *ngIf="institucion">
            <mat-form-field appearance="outline" fxFlex="33" class="px-4">
                <mat-label>Nombre Responsable*</mat-label>
                <input matInput formControlName="a4NombreResponsableInstitucion">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="33" class="px-4">
                <mat-label>Primer Apellido Responsable*</mat-label>
                <input matInput formControlName="a4PrimerApellidoResponsableInstitucion">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="33" class="px-4">
                <mat-label>Segundo Apellido Responsable</mat-label>
                <input matInput formControlName="a4SegundoApellidoResponsableInstitucion">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch" *ngIf="institucion">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Teléfono*</mat-label>
                <input matInput formControlName="a4InstitucionTelefono">
            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Tipo Población*</mat-label>
                <input matInput formControlName="a4RTipoPoblacionInst" [matAutocomplete]="autoInsPoblacionBen">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoInsPoblacionBen="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of insPoblacionFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>

    </div>
</form>
